document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.homepage-hero-slider');
  
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = parseInt(slider.dataset.slideInterval, 10);
    let currentSlide = 0;

    function showSlide(index) {
      slides[currentSlide].style.display = 'none';
      slides[index].style.display = 'block';
      currentSlide = index;
    }

    function nextSlide() {
      showSlide((currentSlide + 1) % slides.length);
    }

    if (autoplay && slides.length > 1) {
      setInterval(nextSlide, interval);
    }
  });
});
